import { motion } from "framer-motion";
import F1 from "../assets/s1.png";
import F2 from "../assets/s2.png";
import F3 from "../assets/s3.png";
import F4 from "../assets/s4.png";
import useModal from "../hooks/useModal";
import Modal from "../components/Modal";
import GEN from "../assets/gen.jpg";

const NuestrosServicios = () => {
  const { open, close, isOpen } = useModal();

  const services = [
    {
      name: "Servicio de recolección y entrega de mercancías.",
      text: "Resolvemos tus necesidades de paquetería de acuerdo con tu presupuesto y urgencia.",
      src: F1,
      modal: false,
    },
    {
      name: "Renta de Generadores de Luz",
      text: "Renta de Generadores de luz de diferentes capacidades, para todo tipo de evento, comercial, industrial, proyectos y residencial.",
      src: F2,
      modal: true,
    },
    {
      name: "Envió y entrega de Diesel o Gasolina",
      text: "Trasladamos y proveemos combustibles a empresa.",
      src: F3,
      modal: false,
    },
    {
      name: "Servicio de envío y paquetería intercompañías",
      text: "Nos especializamos en el envío de documentos y paquetes ligeros como servicio ejecutivo a través de motos para cumplir una entrega rápida y eficiente.",
      src: F4,
      modal: false,
    },
  ];

  return (
    <div className="py-12">
      {/* Título animado */}
      <motion.h2
        className="text-sky-800 text-3xl text-center font-semibold mb-8"
        initial={{ y: -50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        Nuestros servicios
      </motion.h2>

      {/* Grid de servicios */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 px-6 md:px-12">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col"
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: index * 0.3 }}
            viewport={{ once: true }}
          >
            {/* Imagen */}
            <img
              src={service.src}
              alt={service.name}
              className="w-full h-44 object-contain"
            />

            {/* Texto */}
            <div className="p-4 flex flex-col flex-grow">
              <h3 className="text-sky-700 font-semibold text-lg mb-2">
                {service.name}
              </h3>
              <p className="text-gray-600 text-sm flex-grow">{service.text}</p>

              {/* Botón solo si modal:true */}
              {service.modal && (
                <button
                  onClick={open}
                  className="mt-4 px-4 py-2 bg-sky-800 text-white rounded-full hover:bg-sky-700 transition"
                >
                  Ver más
                </button>
              )}
            </div>
          </motion.div>
        ))}
      </div>
	  {isOpen &&
	  	<Modal title="Generador GS Series 6500W" onClose={close}>
			<div className="h-full w-full grid grid-cols-1 md:grid-cols-2 items-center content-center">
				<img src={GEN} alt="generador" className="h-96"/>
				<p>
					Brindan a los clientes potencia de larga duración y un panel de control completo en cualquier momento y lugar.
					Estos motores de generador brindan un enfriador y limpiador de funcionamiento optimizado para alargar la vida del motor con una economía de gasolina mejorada.
				</p>
			</div>
		</Modal>
	  }
    </div>
  );
};

export default NuestrosServicios;
